import React from 'react';

// MatchStake Logo Component - Controller with flames and MS text
const MatchStakeLogo = ({ className = "w-8 h-8", showText = true, textClassName = "" }) => {
  return (
    <div className="flex items-center gap-2">
      <img 
        src="/matchstake-logo.png" 
        alt="MatchStake" 
        className={className}
        style={{ objectFit: 'contain' }}
      />
      {showText && (
        <span className={`font-heading font-bold text-lg ${textClassName}`}>
          MATCHSTAKE
        </span>
      )}
    </div>
  );
};

// Icon-only version for favicon/small spaces
export const MatchStakeIcon = ({ className = "w-8 h-8" }) => {
  return (
    <img 
      src="/matchstake-logo.png" 
      alt="MatchStake" 
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default MatchStakeLogo;
